export interface IReferral {
  name: string;
  creationDate: string;
  city: {
    name: string;
  };
  status: EReferralStatus;
}

export type TReferrals = IReferral[];

export enum EReferralStatus {
  New = 'new',
  OnHold = 'onHold',
  Accepted = 'accepted',
  Rejected = 'rejected',
  Published = 'published',
  Rented = 'rented',
}
